import { Paragraph, TextRun, AlignmentType } from "docx";
import { renderEducationSection } from "./renderEducationSection";
import { renderLeadershipSection } from "./renderLeadershipSection";
import { renderWorkSection } from "./renderWorkSection";
import { renderSkillsInterestsSection } from "./renderSkillsInterestsSection";
import { renderVolunteerSection } from "./renderVolunteerSection";
import { renderAwardsSection } from "./renderAwardSection";
import { renderLifeSection } from "./renderLifeSection";
import { renderCertificateSection } from "./renderCertificateSection"
import { renderCourseworkSection } from "./renderCourseworkSection"
import { createSpacingLine } from "./componentHelpers";

const minimalistTemplate = (
  name,
  city,
  state,
  email,
  work,
  education,
  volunteer,
  awards,
  life,
  leadership,
  certificate,
  coursework,
  skills,
  interests,
  sectionOrder,
  introduction,
) => {
  const typeToSection = {
   "education": renderEducationSection(education),
    "work": renderWorkSection(work),
    "leadership": renderLeadershipSection(leadership),
    "volunteer": renderVolunteerSection(volunteer),
    "award": renderAwardsSection(awards),
    "life": renderLifeSection(life),
    "certificate": renderCertificateSection(certificate),
    "coursework": renderCourseworkSection(coursework),
    "skills": renderSkillsInterestsSection("skills", skills),
    "interests": renderSkillsInterestsSection("interests", interests),
  }

  return {
    styles: {
      default: {
        document: {
          run: {
            font: "Cambria",
          },
        },
      },
    },
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: 720,
              right: 720,
              bottom: 300,
              left: 720,
            },
          },
        },
        children: [
          // Header section for Name and Contact Information
          new Paragraph({
            children: [
              new TextRun({
                text: `${name}`,
                size: 50,
                font: "Cambria",
                characterSpacing: 150,
              }),
              new TextRun({
                text: `${city || "CITY"}, ${state || "STATE"} | ${email}`,
                size: 20,
                break: 1,
              }),
              createSpacingLine,
            ],
            alignment: AlignmentType.CENTER,
          }),
          ...(sectionOrder.map(type => typeToSection[type] || []).flat()),
        ],
      },
    ],
  }
}

export default minimalistTemplate
